export default __webpack_public_path__ + "static/Content-1-318f6faac3df7049b8ccb9c201aca369.mp4";